var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNullIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "#E8E3E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.7258V13.2743C21 13.0308 20.6988 12.8334 20.3273 12.8334H7.67275C7.3012 12.8334 7 13.0308 7 13.2743V14.7258C7 14.9693 7.3012 15.1667 7.67275 15.1667H20.3273C20.6988 15.1667 21 14.9693 21 14.7258Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNullIcon);
export default __webpack_public_path__ + "static/media/null_icon.73384b0c4a1853449ab4929a9dc8e234.svg";
export { ForwardRef as ReactComponent };